import { createTimeMetricHooks } from '@edreamsodigeo/frontend-core';

const {
  useMetric: useFilterTimeMetric,
  useEndMetricEffect: useEndFilterTimeMetricEffect,
} = createTimeMetricHooks('LOAD_FILTERS_FLIGHTS_OF2');

const {
  useMetric: useSortingTimeMetric,
  useEndMetricEffect: useEndSortingTimeMetricEffect,
} = createTimeMetricHooks('LOAD_SORTING_FLIGHTS_OF2');

const {
  useMetric: usePriceTypeFilterTimeMetric,
  useEndMetricEffect: useEndPriceTypeFilterTimeMetricEffect,
} = createTimeMetricHooks('LOAD_PRICE_TYPE_FILTER_FLIGHTS_OF2');

const {
  useMetric: useSearchRequestTimeMetric,
  useEndMetricEffect: useEndSearchRequestTimeMetricEffect,
} = createTimeMetricHooks('REQUEST_TIME_RESULTS_FLIGHTS');

export {
  useFilterTimeMetric,
  useSortingTimeMetric,
  usePriceTypeFilterTimeMetric,
  useEndFilterTimeMetricEffect,
  useEndSortingTimeMetricEffect,
  useEndPriceTypeFilterTimeMetricEffect,
  useSearchRequestTimeMetric,
  useEndSearchRequestTimeMetricEffect,
};
